import { createAction } from 'lib/store-utils';
import { ShiftOffer } from '../../../type/models';
import { DeleteInstancePayload } from '../../../type';

export const BOX_SHIFT_OFFERS_UPDATE_ONE = createAction<ShiftOffer>('Shift offers / update one');
export const BOX_SHIFT_OFFERS_DELETE_ONE = createAction<DeleteInstancePayload>('Shift offers / delete one');
